import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';

import { useEmailUpdater } from 'app/modules/UpdaterEmailForm/useEmailUpdater';
import { Button } from 'app/theme/Button';
import { Form } from 'app/theme/Form';
import { EmailIcon } from 'app/theme/Icons/EmailIcon';
import { LinearLoader } from 'app/theme/LinearLoader';
import { breakpoint } from 'app/theme/theme';
import { common } from 'app/translations/dictionary/common';
import { required, email } from 'app/translations/validators';
import { InputWithIconAndValidation } from 'pkg/components/InputWithIconAndValidation';

const FormContent = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  ${breakpoint.up.md`
    margin-top: 3.3rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start
  `}
`;

const InputWrapper = styled.div`
  width: 100%;
  ${breakpoint.up.md`
    width: calc(100% - 16rem);
    margin-right: 1rem;
  `}
`;

const SubmitButton = styled(Button)`
  &&& {
    margin-top: 1rem;
    height: 4.8rem;
    width: 100%;
    font-size: 1.8rem;
    box-shadow: 0.1rem 0.1rem 0.7rem rgba(0, 0, 0, 0.16);
    ${breakpoint.up.md`
      height: 5.6rem;
      width: 15rem;
      margin-top: 0rem;
      box-shadow: 0.3rem 0.3rem 0.7rem rgba(186, 47, 68, 0.4);
    `};
  }
`;

const CenteredMessage = styled.div`
  text-align: center;
`;

export const UpdaterEmailForm = (): JSX.Element => {
  const { onSubmit, methods, isSuccess, isLoading } = useEmailUpdater();

  if (isSuccess) {
    return <CenteredMessage>{common.updateEmailSuccess}</CenteredMessage>;
  }

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormContent>
          <InputWrapper>
            <InputWithIconAndValidation
              fluid
              disabled={isLoading}
              name="email"
              placeholder="email"
              inputIcon={<EmailIcon />}
              rules={{ ...required, ...email }}
            />
          </InputWrapper>
          <SubmitButton primary disabled={isLoading} type="submit">
            {common.updateEmail}
          </SubmitButton>
        </FormContent>
      </Form>
      <LinearLoader $isLoading={isLoading} />
    </FormProvider>
  );
};
